import {MESSAGE_TYPE} from "../../common/constants/common.constants";
import {toast} from "react-toastify";
import {GeneralStatusEnum} from "../../common/enums/common.enum";
import {theme} from "../../theme";

export const createNotification = (
    messageType: string,
    messageText: string,
    description?: string
) => {
    switch (messageType) {
        case MESSAGE_TYPE.SUCCESS:
            toast.success(messageText)
            break;
        case MESSAGE_TYPE.ERROR:
            toast.error(messageText)
            break;
        default:
            console.warn("Unknown message type:", messageType);
    }
};

export const getStatusColor = (status?: string) => {
    return status === GeneralStatusEnum.ACTIVE
        ? "#97B66B"
        : theme.palette.text.secondary;
};
